// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cMafE","right":"styles_right__23E0C"};